import * as BABYLON from 'babylonjs';
import VisualComponent from './VisualComponent';
import MediaManager from '@/api/MediaManager';

class URLButton extends VisualComponent {
    getType() { return "URLButton"; }

    constructor( { id } = {} ) {
        super( { id });
    }

    construct( context, prefab ) {
        //console.log("Construct URLButton: ")
        const base = super.construct( context, prefab );
        
        this.disable();
        base.getChildMeshes().forEach(mesh => {
            mesh.renderingGroupId = 3;
        });

        //console.log(prefab)
        //console.log(base)
        if(prefab.url) {
            var url = prefab.url;
           
            //console.log(url)
            if(url && url.includes("VideoID:") ){
                const strings = url.split(':');
                //console.log("Trying to get Media")
                //console.log(strings[1])
               // const video = MediaManager.getMedia(parseInt(strings[1]));
                url = strings[1]; //video.getURL();
                //console.log(url)
            }
          


            this.mesh.actionManager = new BABYLON.ActionManager(this.scene);
            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, () => {
                if(prefab.getdisplayInternally() == "true"){
                    window.dispatchEvent(new CustomEvent("openURL",{detail:{url: url,showURL: prefab.getdisplayUrl() == "true"}}));
                }else{
                    window.open(url, "_blank");                  
                }     
            }));
            
            var ease = new BABYLON.CubicEase();
            ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
            
            // Highlight-ring (TODO: enable in CMS)
            // let highlight = BABYLON.MeshBuilder.CreatePlane("", { 
            //     width: this.texture.getWidth() * prefab.getScale() * this.scaleFactor, 
            //     height: this.texture.getHeight() * prefab.getScale() *this.scaleFactor,
            //     sideOrientation: BABYLON.Mesh.DOUBLESIDE 
            // }, window.scene);
            // highlight.visibility = 0;
            // highlight.material = new BABYLON.StandardMaterial("", window.scene);
            // highlight.material.opacityTexture = new BABYLON.Texture( require("@/assets/highlight.png"), window.scene);
            // highlight.material.emissiveColor = BABYLON.Color3.FromHexString(context.primaryColor);
            // highlight.material.disableLighting = true;  
            // highlight.parent = base;
            // highlight.isPickable = false;
                
        
            if(prefab.outTrigger=="disappear"){
            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, () => {
                 BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "visibility", 30,10, this.mesh.visibility, 0, 0, ease);   
            }));
        }

        if(prefab.overTrigger=="appear"){
            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, () => {
                BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "visibility", 30,10, this.mesh.visibility, 1, 0, ease);           
            }));
        }

        if(prefab.outTrigger=="scale"){
            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, () => {
                BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 30,10, this.mesh.scaling, new BABYLON.Vector3.One(), 0, ease);  
            }));
        }

        if(prefab.overTrigger=="scale"){
            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, () => {
                BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 30,10, this.mesh.scaling, new BABYLON.Vector3.One().scale(1.1), 0, ease);          
            }));
        }
    }
        return base;
    }
    

}

export default URLButton;
